export enum PropertyType {
  MULTI_FAMILY = 'Multi-Family',
  SINGLE_FAMILY = 'Single-Family',
  CONDOMINIUM = 'Condominium'
}
